import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Tree } from 'primeng/tree';
import { combineLatest, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { convertToTreeNodes, getSelectedTreeNodes, onlyUniqueString } from '../../helpers/helper';
import { Permission, UserGroupEditor } from '../../interfaces/interfaces';

@Component({
    selector: 'app-usergroupeditor',
    templateUrl: './usergroupeditor.component.html',
    styleUrls: ['./usergroupeditor.component.scss']
})
export class UsergroupeditorComponent extends UnsubscribeComponent implements AfterViewInit {

    userGroupId: number;
    dataLoading = false;
    loading = false;
    userGroupEditorFormGroup: FormGroup = null;
    permissions: Permission[] = [];
    permissionTreeNodes: TreeNode<Permission>[] = [];
    selectedPermissionTreeNodes: TreeNode<Permission>[] = [];
    @ViewChild('tree') tree: Tree = null;
    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    init(): void {
        this.initUserGroupEditorFormGroup();
        this.loadData();
    }

    loadData(): void {
        this.dataLoading = true;
        combineLatest([
            this.apiService.getPermissions(),
            this.userGroupId === null ? of<null>(null) : this.apiService.getUserGroup(this.userGroupId)
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(([getPermissionsResponse, getUserGroupResponse]) => {
            this.permissionTreeNodes = convertToTreeNodes<Permission>(getPermissionsResponse.permissions);
            if (getUserGroupResponse !== null) {
                this.fillUserGroupEditorForm(getUserGroupResponse.userGroupEditor);
                this.selectedPermissionTreeNodes = getSelectedTreeNodes<Permission>(this.permissionTreeNodes, getUserGroupResponse.userGroupEditor.permissions);
            }
        }).add(() => {
            this.dataLoading = false;
        });
    }

    initUserGroupEditorFormGroup(): void {
        this.userGroupEditorFormGroup = new FormGroup({
            name: new FormControl('', [Validators.required])
        });
    }

    fillUserGroupEditorForm(userGroupEditor: UserGroupEditor): void {
        this.userGroupEditorFormGroup.get('name').setValue(userGroupEditor.name);
    }

    save(): void {
        if (this.userGroupEditorFormGroup.invalid) {
            return;
        }
        this.loading = true;
        const userGroupEditorFormValue: any = this.userGroupEditorFormGroup.value;
        if (this.userGroupId === null) {
            this.apiService.createUserGroup({
                name: userGroupEditorFormValue.name,
                permissions: this.selectedPermissionTreeNodes.map(permission => permission.data.id).filter(onlyUniqueString)
            }).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.updateUserGroup(this.userGroupId, {
                name: userGroupEditorFormValue.name,
                permissions: this.selectedPermissionTreeNodes.map(permission => permission.data.id).filter(onlyUniqueString)
            }).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        }
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }

    constructor(
        private apiService: ApiService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
        this.userGroupId = this.config.data.userGroupId;
        this.init();
    }
}
